/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

class AnalyticsContainer extends Component {
	constructor(props) {
		super(props);
		this.analyticsViewRef = React.createRef();
	}

	componentDidMount(){
		this.renderAnalyticsView();
	}

	componentDidUpdate() {
		this.renderAnalyticsView();
	}

	render() {
		return (
			<div className="explore-analytics" ref={this.analyticsViewRef}></div>
		);
	}

	renderAnalyticsView(){
		const analyticsView = this.props.dashboard.getFeature('AnalyticsView');
		const parentNode = this.analyticsViewRef.current;
		if( parentNode && analyticsView ){
			analyticsView.render({ parentNode });
		}
	}
}

AnalyticsContainer.propTypes = {
	dashboard: PropTypes.object.isRequired
};

export default AnalyticsContainer;



// WEBPACK FOOTER //
// ./src/js/components/analytics/AnalyticsContainer.js